import { rolloutFlags } from '@chilipiper/rollout'

export const shouldShowRequestLicenses = () =>
  !rolloutFlags.showRequestLicenseButton || rolloutFlags.showRequestLicenseButton.isEnabled()
